export default __webpack_public_path__ + "static/media/sideLogo.ec710b70.svg";